import React, { ReactNode } from "react"
import CommonHeader from "components/common/CommonHeader"
import CommonFooter from "components/common/CommonFooter"
import styles from "./Layout.module.scss"

interface Props {
  children: ReactNode
}
/**
 * レイアウト（外枠）のコンポーネント
 * ヘッダー・フッターを含む画面の外枠を作る要素
 * ※モーダルを利用する場合は「LayoutWithModal」利用
 * @param {ReactNode} children - 小要素（画面の内側の要素）
 */
const Layout = ({ children }: Props) => {
  return (
    <div className={styles.root}>
      <CommonHeader />
      <div className={styles.contents}>{children}</div>
      <CommonFooter />
    </div>
  )
}

export default Layout
